<div class="nc-measure">
  <div class="nc-measure__title">{{ 'QA_HISTORY.MEASURE' | translate }}</div>
  <div *ngIf="isCreateNCMode; else notCreate"></div>
  <ng-template #notCreate>
    <div class="nc-measure__text">
      {{ nonConformanceModel?.memo }}
    </div>
  </ng-template>
</div>
